import Cookies from "js-cookie";

export function Auths () {
    const level = Cookies.get('level') || "0,0,0,0,0,0,0,0,0,0,0,0,0,0,0";

    // Handle missing cookie
    if (!level) {
        console.warn('Level cookie not found');
        return { approve: () => false };
    }

    let dep = level.split(',').map(l => l === "1");

    function approve(){
        return dep[0] === true || dep[15]===true; // Return the boolean value
        // Or simply: return dep[0];
    }
    function ready(){
        return dep[1]===true || dep[15]===true;
    }
    function invoicing(){
        return dep[2]===true || dep[15]===true;
    }
    function delivery() {
        return dep[3]===true || dep[15]===true;
    }
    function posting(){
        return dep[4]===true || dep[15]===true;
    }
    function ledger(){
        return dep[5]===true || dep[15]===true;
    }
    function cashier(){
        return dep[6]===true || dep[15]===true;
    }
    function inventory(){
        return dep[7]===true || dep[15]===true;
    }
    function report(){
        return dep[8]===true || dep[15]===true;
    }
    function utility(){
        return dep[9]===true || dep[15]===true;
    }
    function afterSales(){
        return dep[10]===true;
    }
    function factory(){
        return dep[11]===true || dep[15]===true;
    }
    function factoryAdmin(){
        return dep[12]===true || dep[15]===true;
    }
    function imports(){
        return dep[13]===true || dep[15]===true;
    }
    function purchase(){
        return dep[14]===true || dep[15]===true;
    }
    function all(){
        return dep[15]===true;
    }


    return {
        approve: approve,
        ready: ready,
        invoicing: invoicing,
        delivery: delivery,
        posting: posting,
        ledger: ledger,
        cashier: cashier,
        inventory: inventory,
        report: report,
        utility: utility,
        afterSales: afterSales,
        factory: factory,
        factoryAdmin: factoryAdmin,
        imports: imports,
        all: all,
        purchase: purchase,
    };
}
